import React from 'react';
import { FlameIcon, HeartPulseIcon } from 'lucide-react';
export function DiscoverySection() {
  return <section className="w-full bg-blue-900 text-white py-16 px-4" data-id="element-32">
      <div className="max-w-4xl mx-auto text-center" data-id="element-33">
        <div className="inline-flex items-center justify-center p-3 bg-blue-800 rounded-full mb-6" data-id="element-34">
          <FlameIcon className="w-8 h-8 text-orange-400" data-id="element-35" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-36">
          El Poder de la Terapia de Calor
        </h2>
        <p className="text-xl text-blue-100 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-37">
          La terapia de calor es recomendada por especialistas para relajar los
          músculos tensos, disminuir los espasmos y aumentar el flujo sanguíneo.
          Nuestra rodillera térmica utiliza tecnología USB para proporcionar un
          calor constante y profundo directamente en la articulación afectada.
        </p>

        <div className="my-12 rounded-2xl overflow-hidden shadow-2xl border-2 border-blue-700/30 max-w-lg mx-auto" data-id="element-38">
          <img src="https://cdn.magicpatterns.com/uploads/ibcTtudjCkvws2WjvZAGwg/ChatGPT_Image_Mar_14,_2026,_07_52_58_AM.png" alt="Hombre usando la rodillera térmica USB en el parque" className="w-full h-auto" data-id="element-39" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left mt-12" data-id="element-40">
          <div className="bg-blue-800/50 p-6 rounded-2xl border border-blue-700/50" data-id="element-41">
            <HeartPulseIcon className="w-10 h-10 text-blue-300 mb-4" data-id="element-42" />
            <h3 className="text-xl font-bold mb-3" data-id="element-43">Recuperación Acelerada</h3>
            <p className="text-blue-100" data-id="element-44">
              El calor dilata los vasos sanguíneos, promoviendo la circulación
              de oxígeno y nutrientes esenciales para reparar el tejido dañado
              más rápido.
            </p>
          </div>
          <div className="bg-blue-800/50 p-6 rounded-2xl border border-blue-700/50" data-id="element-45">
            <FlameIcon className="w-10 h-10 text-orange-400 mb-4" data-id="element-46" />
            <h3 className="text-xl font-bold mb-3" data-id="element-47">Alivio Profundo</h3>
            <p className="text-blue-100" data-id="element-48">
              A diferencia de las cremas tópicas, el calor penetra profundamente
              en la articulación, aliviando la rigidez y mejorando la
              flexibilidad al instante.
            </p>
          </div>
        </div>
      </div>
    </section>;
}